import { Layout, Spin } from 'antd'
import React, { useContext } from 'react'
import { Outlet } from 'react-router-dom'
import PublicContext from '../../PublicContext'
import { Color } from '../../../Common/Color'
import ComputerPublicHeader from '../Header/Computer/ComputerPublicHeader'

export default function ComputerHeaderLayout () {
  const { loading } = useContext(PublicContext)

  return (
    <Layout>
      <ComputerPublicHeader />
      <Layout.Content style={{ overflowY: 'scroll', backgroundColor: Color.white }}>
        <Spin spinning={loading}>
          <Outlet />
        </Spin>
      </Layout.Content>
    </Layout>
  )
}
